/* The Lavashak House — quick-add for lvh-* product cards.
   Posts to /cart/add.js so the shopper never leaves the page they are browsing,
   then falls back to a normal form submit if the fetch fails for any reason. */
(function () {
  'use strict';

  var toast;

  /* Styles live here rather than in a stylesheet so the toast stays a single
     self-contained unit. Injected once, on first use. */
  function injectStyles() {
    if (document.getElementById('lvh-toast-css')) return;
    var s = document.createElement('style');
    s.id = 'lvh-toast-css';
    s.textContent = [
      '.lvh-toast{position:fixed;z-index:60;left:50%;bottom:26px;',
      'transform:translateX(-50%) translateY(20px);display:flex;align-items:center;gap:13px;',
      'max-width:min(92vw,440px);padding:12px 16px;border-radius:16px;background:#2A0A12;',
      'color:#FDF6EC;box-shadow:0 18px 40px -18px rgba(0,0,0,.7);opacity:0;',
      'font-family:var(--lvh-sans,-apple-system,"Segoe UI",sans-serif);',
      'transition:opacity .22s ease,transform .22s ease;}',
      '.lvh-toast.is-on{opacity:1;transform:translateX(-50%) translateY(0);}',
      '.lvh-toast__ico{flex:0 0 26px;width:26px;height:26px;border-radius:50%;',
      'background:#128C4A;display:grid;place-items:center;}',
      '.lvh-toast__ico svg{width:15px;height:15px;stroke:#fff;fill:none;stroke-width:2.4;',
      'stroke-linecap:round;stroke-linejoin:round;}',
      '.lvh-toast__txt{flex:1;min-width:0;}',
      '.lvh-toast__txt b{display:block;font-size:.9rem;font-weight:800;line-height:1.25;}',
      '.lvh-toast__txt span{display:block;font-size:.79rem;line-height:1.35;margin-top:1px;',
      'opacity:.72;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}',
      '.lvh-toast__cta{flex:0 0 auto;color:#E8C56B;font-weight:700;font-size:.85rem;',
      'text-decoration:none;border-bottom:1.5px solid rgba(232,197,107,.45);padding-bottom:1px;}',
      '@media (max-width:620px){.lvh-toast{left:12px;right:84px;bottom:20px;max-width:none;',
      'transform:translateY(20px);}',
      '.lvh-toast.is-on{transform:translateY(0);}}',
      '@media (prefers-reduced-motion:reduce){.lvh-toast{transition:opacity .01s;}}'
    ].join('');
    document.head.appendChild(s);
  }

  function showToast(title) {
    injectStyles();

    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'lvh-toast';
      toast.setAttribute('role', 'status');
      document.body.appendChild(toast);
    }

    toast.innerHTML =
      '<span class="lvh-toast__ico"><svg viewBox="0 0 24 24" aria-hidden="true">' +
      '<path d="M20 6 9 17l-5-5"/></svg></span>' +
      '<span class="lvh-toast__txt"><b>Added to cart</b><span></span></span>' +
      '<a class="lvh-toast__cta" href="/cart">View cart</a>';

    /* textContent, not innerHTML — product titles carry & and quote characters. */
    toast.querySelector('.lvh-toast__txt span').textContent = title || '';

    requestAnimationFrame(function () { toast.classList.add('is-on'); });

    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('is-on'); }, 4200);
  }

  function refreshCart() {
    ['cart:update', 'cart:refresh', 'cart-update'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { source: 'lvh' } }));
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-lvh-add')) return;

    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Adding…';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: Number(form.querySelector('[name="id"]').value),
        quantity: Number(form.querySelector('[name="quantity"]').value || 1)
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function (item) {
        showToast(item.product_title || '');
        refreshCart();
      })
      .catch(function () {
        form.removeAttribute('data-lvh-add');
        form.submit();
      })
      .finally(function () {
        if (btn) {
          btn.disabled = false;
          btn.textContent = label;
        }
      });
  });
})();
